import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
})
export class LoadingBarComponent {
  @Input() text!: string;

  constructor() {}
}
